import { render, staticRenderFns } from "./brandCenter.vue?vue&type=template&id=0140cab5&scoped=true&"
import script from "./brandCenter.vue?vue&type=script&lang=js&"
export * from "./brandCenter.vue?vue&type=script&lang=js&"
import style0 from "./brandCenter.vue?vue&type=style&index=0&id=0140cab5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0140cab5",
  null
  
)

export default component.exports